module.exports = __webpack_public_path__ + "static/aboubakar.e4e3dc11.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/aboubakar.webp
// module id = 915
// module chunks = 3